// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_2i-1";
export var movingGradient = "_2i-4";
export var movingGradientBlock = "_2i-2";
export var skeleton = "_2i-0";
export var skeletonText = "_2i-3";